import React from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../mock";

export const Logo = ({ size = "md" }) => (
  <img
    src="/kplaza-logo.png"
    alt="K PLAZA A.Ş"
    className={`select-none w-auto object-contain mix-blend-multiply ${
      size === "lg" ? "h-14" : "h-8"
    }`}
  />
);

const Navbar = ({ onJoin }) => {
  const scrollToPackages = () => {
    document.getElementById("paketler")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-neutral-100">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" className="shrink-0">
          <Logo />
        </a>
        <nav className="flex items-center gap-3 sm:gap-5">
          <a
            data-testid="navbar-whatsapp-btn"
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`WhatsApp canlı destek ${CONTACT.whatsapp}`}
            className="inline-flex items-center gap-2 bg-green-500 text-white text-sm font-medium px-3 sm:px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden md:inline">Canlı Destek · {CONTACT.whatsapp}</span>
          </a>
          <button
            data-testid="navbar-packages-btn"
            onClick={scrollToPackages}
            className="text-sm font-medium text-neutral-800 hover:text-neutral-500 transition-colors"
          >
            Paketler
          </button>
          <button
            data-testid="navbar-join-btn"
            onClick={onJoin}
            className="bg-black text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-neutral-800 transition-colors"
          >
            Şimdi Katıl
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
